import React, { useState } from 'react';
import api from '../utils/api';
import InventoryListPopup from './InventoryListPopup';
import './styles/TransferInventoryPage.css';
import { BsFiles } from "react-icons/bs";
import { MdDelete } from "react-icons/md";
import { useNavigate } from 'react-router-dom'; 

const StockEntryPage = () => {
    
    const [selectedItem, setSelectedItem] = useState(null);
    const [quantity, setQuantity] = useState('');
    const [price, setPrice] = useState('');
    const [items, setItems] = useState([]);
    const [showInventoryPopup, setShowInventoryPopup] = useState(false);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const handleSelectItem = (item) => {
        setSelectedItem(item);
        setQuantity(''); 
        setPrice('');
        setShowInventoryPopup(false);
    };

    const handleAddItem = () => {
        if (selectedItem && quantity && price) {
        setItems([...items, { ...selectedItem, quantity, price }]);
        setSelectedItem(null);
        setQuantity('');
        setPrice('');
        }
    };

    const calculateTotalHarga = () => {
        const totalInventory = items.reduce((total, item) => {
          return item.price !== 0 ? total + Number(item.price) : total;
        }, 0);
    
        return totalInventory;
    };

    const validateForm = (formData) => {
        const errors = {};
    
        // Cek jika field kosong
        if (!formData.purchase_date) errors.purchase_date = 'Purchase Date is required';
        if (!formData.supplier) errors.supplier = 'Supplier is required';
        if (!formData.purchase_method) errors.purchase_method = 'Puchase Method is required';
        if (!formData.description) errors.description = 'Desciption is required';
    
        return errors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = {
            purchase_date: e.target.purchase_date.value,
            supplier: e.target.supplier.value,
            purchase_method: e.target.purchase_method.value,
            description: e.target.description.value
        };
        
        const validationErrors = validateForm(formData);

        if (Object.keys(validationErrors).length > 0) {
            // Jika ada error, set state errors untuk menampilkan pesan error
            setErrors(validationErrors);
            console.log('Validation Errors:', validationErrors);
            return
        } else {
            const confirmation = window.confirm('Are you sure you want to proceed with this action?');
            if (!confirmation) {
                return;
            }
        }

        const transferData = {
            data: {
                purchaseData: {
                    purchase_date: formData.purchase_date,
                    purchase_amount: calculateTotalHarga(),
                    purchase_method: formData.purchase_method,
                    description: formData.description,
                    supplier: formData.supplier,
                },
                transferData: {
                    transferList: items.map(item => ({
                        inventory_id: item.inventory_id, // Pastikan inventory_id ada di item
                        quantity: item.quantity,
                        price: item.price
                    })),
                },
            }
        };
    
        api.post('/inventory/inventorySave', transferData)
        .then(response => {
          console.log('Student added successfully:', response.data);
          navigate('/success', { state: { message: 'Data berhasil diinput!' } });
        })
        .catch(error => {
          console.error('Error adding inventory:', error);
          navigate('/error', { state: { message: 'Please ask to administrator!' } });
        });
    };
  
    const handleDeleteItem = (index) => {
        const newItems = items.filter((_, i) => i !== index);
        setItems(newItems);
    };

    const formatNumber = (number) => {
        return Number(number).toLocaleString('id-ID', { maximumFractionDigits: 0 });
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Stock Entry</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Item Name</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={selectedItem ? selectedItem.item_name : ''} readOnly />
                                            <BsFiles className="icon" onClick={() => setShowInventoryPopup(true)} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Item Type</label>
                                    </td>
                                    <td>
                                        <input type="text" value={selectedItem ? selectedItem.item_type : ''} readOnly />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Quantity</label>   
                                    </td>
                                    <td>
                                        <input
                                        type="number"
                                        value={quantity}
                                        onChange={(e) => setQuantity(e.target.value)}
                                        />
                                    </td>
                                </tr><tr>
                                    <td>
                                        <label>Price</label>   
                                    </td>
                                    <td>
                                        <input
                                        type="number"
                                        value={price}
                                        onChange={(e) => setPrice(e.target.value)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <button onClick={handleAddItem}>Add</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    <div className="inventory-list">
                        <table>
                            <thead>
                                <tr>
                                    <th className="no-column">No</th>
                                    <th>Item Name</th>
                                    <th>Item Type</th>
                                    <th>Quantity</th>
                                    <th>Price</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((item, index) => (
                                    <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.item_name}</td>
                                    <td>{item.item_type}</td>
                                    <td>{item.quantity}</td>
                                    <td>{formatNumber(item.price)}</td>
                                    <td>
                                        <MdDelete className="icon" onClick={() => handleDeleteItem(index)} />  
                                    </td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td><strong>Total Pembayaran</strong></td>
                                    <td></td>
                                    <td></td>
                                    <td className='table-right-align'><strong>{formatNumber(calculateTotalHarga())}</strong></td>
                                    
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    <div className="search-container">
                        <form onSubmit={handleSubmit}>
                            <table>
                                <tbody>
                                <tr>
                                        <td>
                                            <label>Supplier</label>
                                        </td>
                                        <td>
                                            <input type="text" name="supplier"/>
                                            {errors.supplier && <div className="error-message">{errors.supplier}</div>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Purchase Date</label>
                                        </td>
                                        <td>
                                        <input 
                                            type="date" name="purchase_date" />
                                            {errors.purchase_date && <div className="error-message">{errors.purchase_date}</div>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Purchase Method</label>
                                        </td>
                                        <td>
                                            <input type="text" name="purchase_method"/>
                                            {errors.purchase_method && <div className="error-message">{errors.purchase_method}</div>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Description</label>
                                        </td>
                                        <td>
                                            <input type="text" name="description" />
                                            {errors.description && <div className="error-message">{errors.description}</div>}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <button type="submit" className="profile-button">Submit</button>
                        </form>
                        
                    </div>
                </div>
            </div>
            {showInventoryPopup && (
                <InventoryListPopup onSelectItem={handleSelectItem} onClose={() => setShowInventoryPopup(false)} />
            )}
        </div>
    );
};

export default StockEntryPage;
